import React from "react";
import StepProvider from "./stepper/stepper.provider";
import StepperHeader from "./stepper/stepper.header";
import StepperBody from "./stepper/stepper.body";
import ReclamationProvider from "../../providers/reclamation/reclamation.provider";

interface ICustomClaims {
  colorPrimary: string;
  dobleAuth?: boolean;
  privacyPolicy?: React.ReactNode;
  usernamePrefix?: string;
}

const Claims = ({
  colorPrimary,
  privacyPolicy,
  dobleAuth,
  usernamePrefix,
}: ICustomClaims) => {
  return (
    <ReclamationProvider>
      <StepProvider>
        <StepperHeader colorPrimary={colorPrimary} />
        <StepperBody
          colorPrimary={colorPrimary}
          privacyPolicy={privacyPolicy}
          dobleAuth={dobleAuth}
          usernamePrefix={usernamePrefix}
        />
      </StepProvider>
    </ReclamationProvider>
  );
};

export default Claims;
